"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOWUserEventBodyToJSON = exports.CreateOWUserEventBodyFromJSONTyped = exports.CreateOWUserEventBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CreateOWUserEventBodyFromJSON(json) {
    return CreateOWUserEventBodyFromJSONTyped(json, false);
}
exports.CreateOWUserEventBodyFromJSON = CreateOWUserEventBodyFromJSON;
function CreateOWUserEventBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventType': (0, _1.OWUserSessionEventTypeFromJSON)(json['eventType']),
        'referralCampaign': !(0, runtime_1.exists)(json, 'referralCampaign') ? undefined : json['referralCampaign'],
    };
}
exports.CreateOWUserEventBodyFromJSONTyped = CreateOWUserEventBodyFromJSONTyped;
function CreateOWUserEventBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventType': (0, _1.OWUserSessionEventTypeToJSON)(value.eventType),
        'referralCampaign': value.referralCampaign,
    };
}
exports.CreateOWUserEventBodyToJSON = CreateOWUserEventBodyToJSON;
